<template>
  <div
    class="content"
    :style="
      props.select
        ? {
            background:
              'linear-gradient( 180deg, rgba(0,122,254,0.1) 0%, rgba(0,122,254,0.3) 100%)',
            border: '2px solid #007AFE',
          }
        : {}
    "
  >
    <div class="exclamation">
      <img
        @click.stop="seeRemark"
        src="../../assets/img/exclamation_1.png"
        alt=""
        v-if="props.select"
      />
      <img
        @click.stop="seeRemark"
        src="../../assets/img/exclamation_0.png"
        alt=""
        v-else
      />
    </div>
    <div class="info">
      <div class="name">{{ props.cardItem.packageName }}</div>
      <div class="price">
        ￥<span>{{ props.cardItem.sellingPrice }}</span>
      </div>
      <div class="price2">
        <template v-if="props.cardItem.originPrice">
          ￥<span>{{ props.cardItem.originPrice || "0" }}</span>
        </template>
      </div>
      <div class="time">
        {{
          {
            1: "全时段可用",
            2: "限时段可用",
            3: "夜间时段可用",
          }[props.cardItem.validTime]
        }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { showDialog } from "vant";
// props
const props = defineProps({
  cardItem: {
    type: Object,
    default: () => {
      return {};
    },
  },
  select: {
    type: Boolean,
    default: false,
  },
});
const seeRemark = () => {
  showDialog({
    message: props.cardItem.remark,
    showConfirmButton: false,
    closeOnClickOverlay: true,
    messageAlign: "left",
  });
};
</script>

<style scoped lang="scss">
.content {
  margin-right: 4vmin;
  width: 42.13vmin;
  height: 42.67vmin;
  box-sizing: border-box;
  background: rgba(0, 122, 254, 0.1);
  border-radius: 3.2vmin;
  border: 1px solid rgba(0, 122, 254, 0.15);
  margin-bottom: 4vmin;
}
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  .name {
    font-weight: 600;
    height: 11.2vmin;
    font-size: 4vmin;
    color: #10275b;
    line-height: 5.6vmin;
    max-width: 38.67vmin;
    text-align: center;
  }
  .price {
    font-weight: 400;
    font-size: 3.2vmin;
    color: #10275b;
    margin-bottom: 1.6vmin;
    span {
      font-weight: bold;
      font-size: 8vmin;
      color: #10275b;
      line-height: 9.6vmin;
    }
  }
  .time {
    font-weight: 400;
    font-size: 3.73vmin;
    color: #007bfe;
    line-height: 5.33vmin;
  }
}
.exclamation {
  position: relative;
  margin-bottom: 1.87vmin;
  height: 5.6vmin;
  img {
    position: absolute;
    top: 1.33vmin;
    right: 1.33vmin;
    display: block;
    width: 4.27vmin;
    height: 4.27vmin;
  }
}
.price2 {
  font-weight: 400;
  font-size: 2.67vmin;
  color: #10275b;
  line-height: 3.73vmin;
  height: 3.73vmin;
  text-decoration: line-through;
}
</style>
